export const PLATFORM_ADMIN_EMAILS = ['nawfal.elh@gmail.com', 'omar@fastri.org'] as const;

export function isPlatformAdmin(email?: string | null): boolean {
  if (!email) return false;
  return PLATFORM_ADMIN_EMAILS.includes(
    email.toLowerCase() as (typeof PLATFORM_ADMIN_EMAILS)[number]
  );
}
